const apiUrl = process.env.REACT_APP_API_URL;

export const GetConjuntPildoresEstadistiques = async (idConjunt: string) => {
    try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${apiUrl}:8061/jutge/pildores/${idConjunt}/estadistiques`, {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener les estadistiques del conjunt de pildores:', error);
        return [];
    }
};
